import DefaultHandler from './DefaultHandlers';

export default class MultiselectHandler extends DefaultHandler {
  constructor(overrides) {
    super(['multiselect', 'multiselectLabels', 'multiselectCheckboxes'], overrides);
  }

  canHandle(property) {
    const supportedTypes = ['multiselect', 'multiselectLabels', 'multiselectCheckboxes'];
    return supportedTypes.includes(property.type) && super.canHandle(property);
  }

  handleField(property) {
    const { values, type } = property;

    const formField = super.handleField(property, type);

    if (!formField.optionList) {
      formField.optionList = values;
    }

    return formField;
  }
}
